let BackgroundMusicCache = {};

function Load(src, volumne = 1) {
  let url = src;
  if (!GetFromCache(url)) {
    if (url.toLowerCase().startsWith('http')) {
      let parsedUrl = new URL(url);
      parsedUrl.searchParams.append('source', 'preview');
      url = parsedUrl.toString();
    }
    var audio = new Audio(url);
    audio.volume = volumne;
    audio.loop = true;
    audio.crossOrigin = 'anonymous';
    AddToCache(src, audio);
  }
}
function AddToCache(key, value) {
  BackgroundMusicCache[key] = value;
}
function GetFromCache(key) {
  return BackgroundMusicCache[key];
}
function clearCache() {
  BackgroundMusicCache = {};
}

function detectQueryString(url) {
  // regex pattern for detecting querystring
  var pattern = new RegExp(/\?.+=.*/g);
  return pattern.test(url);
}
export default { Load, AddToCache, GetFromCache, clearCache };
